import { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { IconWithText } from './icon-with-text';

interface Props {
  copyText: string;
  copyLabel?: string;
  copiedLabel?: string;
  size?: number;
  trackingId?: string;
}

export const CopyButton = ({ copyText, copyLabel = 'Copy', copiedLabel = 'Copied', size = 14, ...rest }: Props) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };
  return (
    <CopyToClipboard text={copyText} onCopy={handleCopy}>
      <IconWithText size={size} iconName={copied ? 'check' : 'copy'} {...rest}>
        {copied ? copiedLabel : copyLabel}
      </IconWithText>
    </CopyToClipboard>
  );
};
